import { useQueryClient } from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'
import { PROFILE } from '../api/keys'
import { forgetAccount } from '../query'

export function useSignOut(leave: () => Promise<unknown>, to = '/sign-in'): () => Promise<void> {
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  return async () => {
    await leave()
    forgetAccount(queryClient)
    queryClient.setQueryData(PROFILE, null)
    await navigate({ to, replace: true })
  }
}
